import React, { useState } from 'react';
import TopBar from "../components/TopBar";
import Footer from "../components/Footer";
import "../App.css";
import "./BookingForm.css";

function BookingForm() {
  const [formData, setFormData] = useState({
    fullName: '',
    emailAddress: '',
    phoneNumber: '',
    careRecipientName: '',
    careRecipientAge: '',
    relationshipToCareRecipient: '',
    staffGenderPreference: '',
    typeOfCare: '',
    preferredSchedule: '',
    preferredStartDate: '',
    serviceLocation: '',
    preferredContactMethod: '',
    additionalDetails: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const emailBody = `
      Full Name: ${formData.fullName}\n
      Email Address: ${formData.emailAddress}\n
      Phone Number: ${formData.phoneNumber}\n
      Care Recipient Name: ${formData.careRecipientName}\n
      Care Recipient Age: ${formData.careRecipientAge}\n
      Relationship to Care Recipient: ${formData.relationshipToCareRecipient}\n
      Staff Gender Preference: ${formData.staffGenderPreference}\n
      Type of Care: ${formData.typeOfCare}\n
      Preferred Schedule: ${formData.preferredSchedule}\n
      Preferred Start Date: ${formData.preferredStartDate}\n
      Service Location: ${formData.serviceLocation}\n
      Preferred Contact Method: ${formData.preferredContactMethod}\n
      Additional Details: ${formData.additionalDetails}\n
    `;

    window.location.href = `mailto:info@example.com?subject=Booking Request&body=${encodeURIComponent(emailBody)}`;
  };

  return (
    <div className='App'>
      <TopBar />
      <div className="App-header-services" id="booking-form" style={{ padding: '8vw 8px 8px 8px', marginBottom: '10vh' }}>
        <div className="booking-text" style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
          <h1 className="hero-title" >Book a Service</h1>
          <p className="hero-subtitle" style={{ fontSize: '1.2rem', color: '#333', marginBottom: '32px' }}>
            Fill out the form below to book a service with us. We'll get back to you to confirm your booking.
          </p>
          <form onSubmit={handleSubmit} className="booking-form-container">
            <input 
              type="text" 
              name="fullName" 
              placeholder="Full Name" 
              required 
              className="booking-form-input"
              value={formData.fullName}
              onChange={handleChange}
            />
            <input 
              type="tel" 
              name="phoneNumber" 
              placeholder="Phone Number" 
              required 
              className="booking-form-input"
              value={formData.phoneNumber}
              onChange={handleChange}
            />
            <input 
              type="email" 
              name="emailAddress" 
              placeholder="Email Address" 
              required 
              className="booking-form-input"
              value={formData.emailAddress}
              onChange={handleChange}
            />

            <h3>Care Recipient Information</h3>
            <input 
              type="text" 
              name="careRecipientName" 
              placeholder="Full Name of Care Recipient" 
              required 
              className="booking-form-input"
              value={formData.careRecipientName}
              onChange={handleChange}
            />
            <input 
              type="number" 
              name="careRecipientAge" 
              placeholder="Age of Care Recipient" 
              required 
              className="booking-form-input"
              value={formData.careRecipientAge}
              onChange={handleChange}
              min="0"
              title="Please enter a valid age."
            />
            <input 
              type="text" 
              name="relationshipToCareRecipient" 
              placeholder="Relationship to Care Recipient" 
              required 
              className="booking-form-input"
              value={formData.relationshipToCareRecipient}
              onChange={handleChange}
            />
            <select 
              name="staffGenderPreference" 
              required 
              placeholder="CHC Staff Gender Preference"
              className="booking-form-select"
              value={formData.staffGenderPreference}
              onChange={handleChange}
            >
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </select>
            <input 
              type="text" 
              name="typeOfCare" 
              placeholder="Type of Care Needed" 
              required 
              className="booking-form-input"
              value={formData.typeOfCare}
              onChange={handleChange}
            />
            <select 
              name="preferredSchedule" 
              required 
              placeholder="Preferred Schedule"
              className="booking-form-select"
              value={formData.preferredSchedule}
              onChange={handleChange}
            >
              <option value="Full-Time Care">Full-Time Care</option>
              <option value="Part-Time Care">Part-Time Care</option>
              <option value="Overnight Care">Overnight Care</option>
            </select>
            <input 
              type="text" 
              name="preferredStartDate" 
              placeholder="Preferred Start Date (dd/mm/yyyy)" 
              required 
              className="booking-form-input"
              title="Please enter the date in dd/mm/yyyy format."
              value={formData.preferredStartDate}
              onChange={handleChange}
            />
            <input 
              type="text" 
              name="serviceLocation" 
              placeholder="Service Location (City / Postal Code)" 
              required 
              className="booking-form-input"
              value={formData.serviceLocation}
              onChange={handleChange}
            />
            <select 
              name="preferredContactMethod" 
              required 
              placeholder="Preferred Contact Method"
              className="booking-form-select"
              value={formData.preferredContactMethod}
              onChange={handleChange}
            >
              <option value="Phone">Phone</option>
              <option value="Email">Email</option>
              <option value="Text Message">Text Message</option>
            </select>

            <h3>Additional Details</h3>
            <textarea 
              name="additionalDetails" 
              placeholder="Tell us more about your care need or other specialty service you require" 
              rows="5" 
              className="booking-form-textarea"
              value={formData.additionalDetails}
              onChange={handleChange}
            />
            <button 
              type="submit" 
              className="button-arrow"
            >
              Submit Booking
            </button>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default BookingForm;